export const ErrorCode = {
  // Common
  '0': '成功',
  '1181000': '傳入的 callback 非 function',
  '1185005': '參數錯誤',
  '1189999': '例外',

  // MID
  '1181001': '需要使用手機進行門號身分識別',
  '1181002': '請關閉 WIFI 網路，改用 4G/5G 網路',
  '1182002': '電信網路驗證通訊失敗',
  '1185007': '請關閉 WIFI 網路並確認電信業者是否正確',
  '1185009': '偵測到您使用的電信商可能非中華電信，中華電信連線逾時',

  // Cert
  '1185010': '無憑證',
  '1185011': '無憑證，生成 CertTx',
  '1185012': '無憑證，取得 CSR 失敗',
  '1185061': '簽章失敗',
  '1185071': '憑證密碼錯誤',
  '1185112': '讀取憑證失敗',

  // ATL Agent
  '1182000': '偵測不到用戶端服務啟動中或版本不符',
  '1186000': '中介元件產生認證碼失敗',
  '1186001': '中介元件認證失敗',
  '1186100': '無卡片或找不到憑證',
  '1186101': '卡片已鎖定',
  '1186102': '驗證 PIN 碼失敗',
  '1186103': '挑選憑證失敗',
  '1186104': '簽章作業失敗',
  '1186105': '押碼作業失敗',
  '1186110': '讀取金融卡卡片資料錯誤',
  '1186111': '讀取金融卡卡片資料錯誤，建議使用其他金融卡進行驗證',
  '1186112': '此卡別無法使用此服務，建議使用其他金融卡進行驗證',

  // Deprecated
  '118a001': '元件產生認證碼失敗',
  '118a002': '元件產生認證碼失敗: ', // 附加元件訊息
  '118a005': '元件認證失敗',
  '118b001': '中介產生認證碼失敗',
  '118b005': '中介認證失敗',
  '118c001': '簽章失敗',
  '118c002': '簽章失敗: ', // 附加元件訊息
  '118d001': '挑選憑證失敗',
  '118d002': '挑選憑證失敗: ', // 附加元件訊息
  '118d003': '簽章失敗',
  '118d004': '簽章失敗: ', // 附加元件訊息
  '118t001': '請將 ATM 金融卡插入您的讀卡機',
  '118t002': '讀取卡片資料錯誤',
  '118t003': '讀取此金融卡資料有誤，建議使用其他金融卡進行驗證',
  '118t004': '此卡別無法使用此服務，建議你可使用其他金融卡進行驗證',
  '118t007': '密碼錯誤',
  '118t008': '押碼失敗',

  // MID Server
  '3641000': '請聯絡客服人員排除問題。',
  '3641001': '請聯絡客服人員排除問題。',
  '3641002': '請聯絡客服人員排除問題。',
  '3641003': '請聯絡客服人員排除問題。',
  '3641004': '請聯絡客服人員排除問題。',
  '3641005': '請聯絡客服人員排除問題。',
  '3641006': '請聯絡客服人員排除問題。',
  '3641007': '請聯絡客服人員排除問題。',
  '3641008': '請聯絡客服人員排除問題。',
  '3641010': '請聯絡客服人員排除問題。',
  '3641020': '請聯絡客服人員排除問題。',
  '3641021': '請聯絡客服人員排除問題。',
  '3641022': '請聯絡客服人員排除問題。',
  '3641023': '請聯絡客服人員排除問題。',
  '3641024': '請聯絡客服人員排除問題。',
  '3641025': '系統維護中，請稍後再試。',
  '3641026': '系統維護中，請稍後再試。',
  '3641027': '系統維護中，請稍後再試。',
  '3641030': '請聯絡客服人員排除問題。',
  '3641031': '請聯絡客服人員排除問題。',
  '3641032': '請聯絡客服人員排除問題。',
  '3641040': '請聯絡客服人員排除問題。',
  '3641041': '請聯絡客服人員排除問題。',
  '3641042': '與基地台連線成功但資料異常，您的電信服務可能不支援在漫遊下驗證，或請(1)確認網路訊號(2)關閉熱點分享(3)關閉且重開4G/5G行動數據，或請稍後再試。',
  '3641043': '請聯絡客服人員排除問題。',
  '3641044': '請聯絡客服人員排除問題。',
  '3641045': '請聯絡客服人員排除問題。',
  '3641046': '生日輸入格式錯誤。',
  '3641047': '請聯絡客服人員排除問題。',
  '3641048': '請聯絡客服人員排除問題。',
  '3641049': '門號格式輸入錯誤。',
  '3641050': '身分證字號格式輸入錯誤。',
  '3641051': '請聯絡客服人員排除問題。',
  '3641052': '請聯絡客服人員排除問題。',
  '3641053': '請聯絡客服人員排除問題。',
  '3641054': '請聯絡客服人員排除問題。',
  '3641055': '請聯絡客服人員排除問題。',
  '3641056': '請聯絡客服人員排除問題。',
  '3641057': '請聯絡客服人員排除問題。',
  '3641058': '請聯絡客服人員排除問題。',
  '3641059': '請聯絡客服人員排除問題。',
  '3641060': '您的電信業者不支援此服務。',
  '3641070': '',
  '3641100': '請聯絡客服人員排除問題。',
  '3641101': '請聯絡客服人員排除問題。',
  '3641102': '請聯絡客服人員排除問題。',
  '3641103': '請聯絡客服人員排除問題。',
  '3641104': '請聯絡客服人員排除問題。',
  '3641105': '請聯絡客服人員排除問題。',
  '3641106': '請聯絡客服人員排除問題。',
  '3641107': '請聯絡客服人員排除問題。',
  '3641110': '請聯絡客服人員排除問題。',
  '3641120': '請聯絡客服人員排除問題。',
  '3641122': '請聯絡客服人員排除問題。',
  '3641141': '請聯絡客服人員排除問題。',
  '3641142': '請聯絡客服人員排除問題。',
  '3641143': '請聯絡客服人員排除問題。',
  '3641144': '請聯絡客服人員排除問題。',
  '3641146': '生日格式輸入錯誤。',
  '3641149': '門號格式輸入錯誤。',
  '3641150': '身分證字號格式輸入錯誤。',
  '3641151': '請聯絡客服人員排除問題。',
  '3641152': '請聯絡客服人員排除問題。',
  '3641153': '請聯絡客服人員排除問題。',
  '3641154': '請聯絡客服人員排除問題。',
  '3641155': '請聯絡客服人員排除問題。',
  '3641156': '請聯絡客服人員排除問題。',
  '3641158': '請聯絡客服人員排除問題。',
  '3641159': '請聯絡客服人員排除問題。',
  '3641170': '請聯絡客服人員排除問題。',
  '3642000': '請聯絡客服人員排除問題。',
  '3642100': '系統維護中，請稍後再試。',
  '3643000': '請聯絡客服人員排除問題。',
  '3643100': '系統維護中，請稍後再試。',
  '3644000': '系統維護中，請稍後再試。',
  '3644001': '系統忙碌中，請稍後再試。',
  '3644002': '請聯絡客服人員排除問題。',
  '3644004': '請聯絡客服人員排除問題。',
  '3644010': '系統維護中，請稍後再試。',
  '3644011': '系統維護中，請稍後再試。',
  '3644012': '系統維護中，請稍後再試。',
  '3644013': '該門號電信業者暫停服務(系統維護中)。請稍後再試。',
  '3644029': '驗證錯誤次數太多，請10分鐘後再試。\n本服務限本國籍人士申辦之月租型4/5G門號並使用該門號上網，如您是使用親子卡、預付卡、外國人門號、企業門號、二類電信(目前只有 LINE MOBILE 及統一超商電信可使用)、未正常繳費門號、非支援之電信業者等等，無法使用本服務。',
  '3644100': '系統維護中，請稍後再試。',
  '3644101': '系統維護中，請稍後再試。',
  '3645000': '系統維護中，請稍後再試。',
  '3645001': '系統維護中，請稍後再試。',
  '3645002': '您輸入手機門號與電信業者不符。請確認您的手機門號、電信業者、身分證統一編號是否為申報人本人申請資料。請關閉WIFI，確認使用電信業者行動網路(4G/5G)連線後，再重新操作。',
  '3645003': '門號與電信業者不符，該門號不屬於您所選的電信業者。',
  '3645007': '您上網使用的IP與所選的電信業者不符，若您使用WIFI請關閉，若使用雙卡機請確認上網SIM卡屬於那一家電信業者。\n',
  '3645009': '您的上網IP不屬於中華電信,請關閉WIFI或請確認您的電信業者資訊是否正確.',
  '3645011': '門號與身分證字號不符，該確認本手機門號申請人之身分證字號是否輸入正確。',
  '3645012': '請聯絡客服人員排除問題。',
  '3645013': '與基地台連線成功但資料異常，您的電信服務可能不支援在漫遊下驗證，或請(1)確認網路訊號(2)關閉熱點分享(3)關閉且重開4G/5G行動數據，或請稍後再試。',
  '3645014': '請檢查輸入門號資料是否正確，若使用的是雙卡機，請檢查雙卡機所使用的行動數據SIM卡，屬於哪一家電信業者。',
  '3645015': '請檢查輸入門號資料是否正確，若使用的是雙卡機，請檢查雙卡機所使用的行動數據SIM卡，屬於哪一家電信業者。',
  '3645016': '驗證失敗，請檢查輸入身分證字號、生日與門號資料是否正確。若確認正確，請洽電信業者確認留存在電信業者之資料是否正確。',
  '3645017': '您使用的網路連線與手機門號、電信業者不符。請關閉WiFi，並改用電信業者行動網路(4G/5G)連線，並確認網路訊號正常。請將手機預設瀏覽器設為Safari或Chrome。若您的作業系統為 iOS 15，且有付費iCloud，請於「設定」->「iCloud」->「私密轉送」中關閉私密轉送功能。亦可參考： https://www.twca.com.tw/product/cf82e8ad-1b3b-45df-b8db-6ac13d2c250e',
  '3645018': '請聯絡客服人員排除問題。',
  '3645019': '您留存於電信業者的申辦資料異常，請確認輸入資料是否正確。請檢查手機門號與電信業者是否正確，請確認您的手機門號是否為申報人本人申請之月租型門號。',
  '3645021': '您的手機門號無法使用行動電話認證服務，如：已掛失，已退租， 欠費中等。請檢查手機門號與電信業者是否正確，請確認您的手機門號是否為申報人本人申請之月租型門號。',
  '3645022': '請聯絡客服人員排除問題。',
  '3645023': '您的手機門號不提供上網服務。請檢查手機門號與電信業者是否正確，請確認您的手機門號是否為申報人本人申請之月租型門號。',
  '3645024': '您的手機門號無法使用行動電話認證服務，如：預付卡、企業卡、親子卡等。請檢查手機門號與電信業者是否正確，請確認您的手機門號是否為申報人本人申請之月租型門號。',
  '3645025': '請聯絡客服人員排除問題。',
  '3645031': '請聯絡客服人員排除問題。',
  '3645032': '請聯絡客服人員排除問題。',
  '3645033': '請聯絡客服人員排除問題。',
  '3645034': '請聯絡客服人員排除問題。',
  '3645097': '電信業者維護中，請稍後再試。',
  '3645098': '電信業者維護中，請稍後再試。',
  '3645099': '電信業者維護中，請稍後再試。',
  '3645100': '系統維護中，請稍後再試。',
  '3645198': '系統維護中，請稍後再試。',
  '3645199': '系統維護中，請稍後再試。',
  '3649997': '系統維護中，請稍後再試。',
  '3649998': '系統維護中，請稍後再試。',
  '3649999': '系統維護中，請稍後再試。'
};
